import 'alpinejs';
import 'lazysizes';
import ScrollOut from "scroll-out";
import './polyfills';
// import './a11y-video';
import './arrows';
import './people-labels';
import './scroll-anims';

ScrollOut({
  once: true,
  threshold: 0.3,
});


window.addEventListener("DOMContentLoaded", (event) => {
  var headerStuck = pageYOffset > 0;
  const siteHeader = document.querySelector('.SiteHeader');
  if (headerStuck && siteHeader) {
    siteHeader.classList.add('is-stuck');

    const headerTalk = siteHeader.querySelector('.SiteHeader-talk');
    if (headerTalk) {
      headerTalk.style = '';
    }
  }
});